export const pallete = [
    "#0066cc", "#005cb8", "#0052a3", "#00478f", "#003d7a", "#003366", "#002952",
    "#0066cc", "#1a75d1", "#3385d6", "#4d94db", "#66a3e0", "#80b3e6", "#99c2eb", "#b3d1f0", "#cce0f5",
    "#00ccff", "#00b8e6", "#00a3cc", "#008fb3", "#007a99", "#006680", "#005266", "#003d4c",
    "#00ccff", "#1ad1ff", "#33d6ff", "#4ddbff", "#66e0ff", "#80e6ff", "#99ebff", "#b3f0ff", "#ccf5ff",
    "#33cccc", "#2eb8b8", "#29a3a3", "#248f8f", "#1f7a7a", "#1a6666", "#145252", "#0f3d3d",
    "#33cccc", "#47d1d1", "#5cd6d6", "#70dbdb", "#85e0e0", "#99e6e6", "#adebeb", "#c2f0f0", "#d6f5f5",
    "#99cc00", "#8ab800", "#7aa300", "#6b8f00", "#5c7a00", "#4d6600", "#3d5200", "#2e3d00",
    "#99cc00", "#a3d11a", "#add633", "#b8db4d", "#c2e066", "#cce680", "#d6eb99", "#e0f0b3", "#ebf5cc",
    "#ffcc33", "#e6b82e", "#cca329", "#b38f24", "#997a1f", "#80661a", "#665214",
    "#ffcc33", "#ffd147", "#ffd65c", "#ffdb70", "#ffe085", "#ffe699", "#ffebad", "#fff0c2", "#fff5d6",
    "#ff7070", "#ff8585", "#ff9999", "#ffadad", "#ffc2c2", "#ffd6d6",
    "#b2481b", "#a04118", "#8e3a16", "#7d3213",
    "#b2481b", "#ba5a32", "#c16d49", "#c97f5f", "#d19176", "#d9a48d", "#e0b6a4", "#e8c8bb", "#f0dad1",
    "#9900cc", "#8a00b8", "#7a00a3", "#6b008f", "#5c007a", "#4d0066",
    "#9900cc", "#a31ad1", "#ad33d6", "#b84ddb", "#c266e0", "#cc80e6", "#d699eb", "#e0b3f0", "#ebccf5",
];